
import { ELinkType } from '@/utils/enums'
import { isBizSdAvailable } from '@/utils/bizBrowser/sendToBizBrowser'
import { Options, Vue } from 'vue-class-component'
import { PropSync, Prop } from 'vue-property-decorator'

@Options({
  components: {},
  name: 'LinkingOptionsDialog',
  emits: ['showScanMethodDialog'],
})
export default class LinkingOptionsDialog extends Vue {
  @PropSync('isShow', { type: Boolean }) _isShow!: boolean

  ELinkType = ELinkType

  get isBizBrowserEnabled() {
    return isBizSdAvailable()
  }

  link(linkType: ELinkType) {
    this._isShow = false

    if (this.isBizBrowserEnabled) {
      this.$emit('showScanMethodDialog', `${linkType}-scan`)
      return
    }

    this.$router.push({
      name: `${linkType}-scan`,
      params: {
        project: this.$store.getters.projectParam,
        barcodeId: this.$store.state.barcode.barcode?.id,
      },
    })
  }
}
